<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="900px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Duomenų naikinimas pagal aktą</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-row align="baseline" class="mb-0">
              <v-col cols="12" class="mb-2">
                Ar tikrai norite sunaikinti duomenis pagal
                <strong>aktą Nr. {{ item.nak_id }}</strong>
              </v-col>
              <v-col cols="12" md="12" class="mb-4">
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label="Patvirtinu, kad duomenų naikinimo aktas yra pasirašytas."
                  :validate-key="`tvirtinimas`"
                  required
                  v-model="formData.tvirtinimas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="DVS numeris"
                  tooltip="Archyvo naikinimas. Akto naikinimas. DVS numeris"
                  required
                  v-model="formData.nak_dvs_numeris"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="DVS registracijos data"
                  tooltip="Archyvo naikinimas. Akto naikinimas. DVS registracijos data"
                  required
                  v-model="formData.nak_dvs_data"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()" :loading="loading">
          Atšaukti
        </el-button>
        <el-button primary :loading="loading" @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalAktasNaikinti',
  props: {
    value: Boolean,
    item: Object,
    loading: Boolean,
  },
  data() {
    return {
      formData: {
        tvirtinimas: false,
        nak_dvs_numeris: null,
        nak_dvs_data: null,
      },
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['prasymasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.formData = {
          tvirtinimas: false,
          nak_dvs_numeris: null,
          nak_dvs_data: null,
        }
        this.$validator.reset()
        this.$emit('input', value)
      },
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          window._VMA.$emit('FORMAT_ERROR')
          return
        }

        const data = {
          nak_id: this.item.nak_id,
          ...this.formData,
        }
        this.$emit('confirmAktasNaikinti', data)
      })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
